import React from "react";
import "./radio_buttons.scss";

const RadioOption = ({ option, isSelected, onChange }) => {
  return (
    <div className="radio-button-option-container" onClick={() => onChange(option.value)}>
      <div className={`radio-outer-circle ${!isSelected && "unselected"}`}>
        <div className={`radio-inner-circle ${!isSelected && "unselected-circle"}`} />
      </div>
      <div className="helper-text">{option.label}</div>
    </div>
  );
};

export default RadioOption;
